import { useState } from 'react'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '../../hooks/useInfiniteQuery.js'
import { InternalGrid, type InternalGridProps } from './InternalGrid.js'

export const getFieldPriorityByType = (field: any) => {
  if (field.grid.type === 'media') return 0
  if (field.grid.type === 'title') return 1
  return 2
}

type GridColumnWidth = 'regular' | 'large'

type GridProps = Pick<
  InternalGridProps,
  | 'data'
  | 'fields'
  | 'select'
  | 'onSelectChange'
  | 'itemActions'
  | 'onItemClick'
>

const Grid = (props: GridProps) => {
  return <InternalGrid {...props} />
}

type VirtualizedGridProps = Pick<
  InternalGridProps,
  | 'data'
  | 'fields'
  | 'select'
  | 'onSelectChange'
  | 'itemActions'
  | 'onItemClick'
>

const VirtualizedGrid = ({ data, ...props }: GridProps) => {
  const [scroll, setScroll] = useState({ first: 0, last: 0 })

  return (
    <InternalGrid
      virtualized
      data={data.slice(scroll.first, scroll.last)}
      totalCount={data.length}
      onScroll={(first, last) => {
        if (scroll.first !== first || scroll.last !== last) {
          setScroll({ first, last })
        }
      }}
      {...props}
    />
  )
}

type BasedGridProps = Omit<UseInfiniteQueryOptions, 'view'> &
  Pick<
    InternalGridProps,
    'fields' | 'select' | 'onSelectChange' | 'itemActions' | 'onItemClick'
  >

const BasedGrid = ({
  query,
  transformQueryResult,
  ...props
}: BasedGridProps) => {
  const { data } = useInfiniteQuery({
    query,
    transformQueryResult,
  })

  return (
    <InternalGrid
      data={data}
      totalCount={0}
      onScroll={() => {}}
      virtualized
      {...props}
    />
  )
}

export { InternalGrid, Grid, VirtualizedGrid, BasedGrid }
export type {
  InternalGridProps,
  GridProps,
  VirtualizedGridProps,
  BasedGridProps,
  GridColumnWidth,
}
